import { SearchForm } from "mixs/base/search_mixin";
import { get } from "apps/actions/common"

class Search extends SearchForm {
}

riot.mixin("forms.heat_treatments.search", Search as riot.TagMixin);
